import { getCountryCallingCode, isSupportedCountry } from 'libphonenumber-js/max';

import { getAlpha2Codes, type Alpha2Code } from 'i18n-iso-countries';
import type { CountryCode } from 'libphonenumber-js/max';

export interface CountryType {
  readonly code: Alpha2Code;
}

export interface CallableCountryType {
  readonly code: CountryCode;
  readonly callingCode: string;
}

export const COUNTRIES: readonly CountryType[] = Object.keys(getAlpha2Codes()).map(code => ({ code: code as Alpha2Code }));

export const CALLABLE_COUNTRIES: CallableCountryType[] = COUNTRIES
  .filter((country) => isSupportedCountry(country.code))
  .map(
    (country) => ({
      code: country.code,
      callingCode: getCountryCallingCode(country.code as CountryCode),
    })) as CallableCountryType[];
